export default {
  name: 'approval',
  translationKey: 'approval-module',
  routePrefix: 'approval-workflow',
  routeNamePrefix: 'admin.approval',
  directRoutesAvailable: false,
}
